/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>菜单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->

    <div style=" float: right; margin-right: 50px; margin-bottom: 20px; ">
      <el-button type="success" icon="el-icon-plus" @click="addCogilg">添加菜单</el-button>
    </div>


    <!--列表-->
    <el-table :data="listData" lazy  row-key="id" border
      :tree-props="{ children: 'children' }">

      <el-table-column prop="name" label="菜单名称" width="200">
        <!-- <template slot-scope="scope">
          <div>{{scope.row.name}}
           
          </div>  
        </template> -->

      
      </el-table-column>
     
      <el-table-column prop="name" label="菜单icon"  align="center" width="100">
   
        
        <template slot-scope="scope">
         <i :class="scope.row.icon" style="font-size: 30px;"></i>
        </template>

      
      </el-table-column>
      <el-table-column prop="url" label="菜单路径"  align="center" width="300"></el-table-column>
      <el-table-column align="right"  label="操作" >
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" @click="onClick(scope.row, 1)">编辑</el-button>
          <el-button type="danger" icon="el-icon-delete" @click="onClick(scope.row, 2)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>


    <el-dialog title="菜单列表" width="30%" :visible.sync="dialogFormVisible">
      <el-form :model="editForm" label-width="100px" :rules="rules" ref="editForm">
        <el-form-item label="菜单类别" prop="type">
          <el-radio-group v-model="editForm.type">
            <el-radio label="1">目录</el-radio>
            <el-radio label="2">页面</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="parentId" label="上级菜单:" v-if="editForm.type == 2">
          <el-select clearable v-model="editForm.parentId" placeholder="请选择">
            <el-option v-for="item in SelectList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单名称" prop="name">
          <el-input v-model="editForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="菜单url" prop="url" v-if="editForm.type == 2">
          <el-input v-model="editForm.url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="菜单排序" prop="sort">
          <el-input v-model="editForm.sort" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="菜单icon" prop="icon" >


          <el-select v-model="editForm.icon" placeholder="请选择">
            <el-option v-for="item in options" :key="item.name" :label="item.name" :value="item.name">

              <i :class="item.name" style="font-size: 33px;"></i>
            </el-option>
          </el-select>
          <!-- <el-input v-model="editForm.icon"    autocomplete="off"></el-input> -->
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addRole('editForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import add from '../../api/index'
import { roleDelete, getMenuList, menuAdd, getParentList, menuList,menuDelete } from '../../api/userMG'
import Axios from 'axios'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      dialogVisible: false,
      value: "",
      options123: [],
      drawer: false,
      options: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      ssoServer: "",
      formLabelWidth: '120px',
      dialogFormVisible: false,
      options1234123: [],
      ifindex: "",
      aData: new Date(),

      adder: "",
      recommendform: {
        index: "",
        id: ""
      },
      roleId: "",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList: [],
      SelectList: '',
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',

      editForm: {
        type: "",
        icon: '',
        parentId: "",
        url: "",
        name: '',
        sort: ""
      },

      // rules表单验证
      rules: {

        icon: [{ required: true, message: '菜单icon不能为空', trigger: 'blur' }],
        parentId: [{ required: true, message: '上级菜单不能为空', trigger: 'blur' }],
        sort: [{ required: true, message: '菜单排序不能为空', trigger: 'blur' }],

        url: [{ required: true, message: '菜单url不能为空', trigger: 'blur' }],
        type: [
          { required: true, message: '菜单类别不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '菜单名称不能为空', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        name: "",
        current: 1,
        size: 20,
      },
      ids: "",
      userparm: [], //搜索权限
      listData: '', //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },

  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.options=add
    this.ongetParentList()
  
   
    this.roleId = JSON.parse(localStorage.getItem('userlist'))
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    this.value = (new Date()).getTime();
    let tokenId = localStorage.getItem('tokenId');
    this.adder = tokenId
  },
  mounted() {
    this.formLIst()
   



  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
  ongetParentList(){
    getParentList().then(res => {
      this.SelectList = res.data
    })
  },
    onClick(row, index) {
      if (index == 2) {
        this.$confirm('此操作将永久删除角色, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          menuDelete({
            id: row.id
          }).then(res => {
            if (res.code == 0) {
              this.formLIst()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
        // 删除
      } else {
        this.ifindex = '2'
        this.dialogFormVisible = true
        this.editForm = row
        this.editForm.type = String(row.type)

        // 编辑

      }
    },





    addRole(editForm) {
      this.$refs[editForm].validate((valid) => {
        if (valid) {
          if (this.ifindex == 2) {
            // 编辑
            menuList(this.editForm).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '修改成功'
                })
                this.formLIst()
                
                this.dialogFormVisible = false
              }

            })

          } else {
            menuAdd(this.editForm).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '添加成功'
                })
                this.formLIst()
                this.ongetParentList()
                this.dialogFormVisible = false
              }

            })
            //添加
          }

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },




    // addRole(){
    //     console.log(this.editForm);
    //     return
    //     if(this.ifindex==1){
    //         roleAdd({
    //         name:this.editForm.name
    //     }).then(res=>{
    //     if(res.code==0){
    //         this.$message({
    //             type: 'success',
    //             message: '添加成功'
    //           })
    //           this.formLIst()
    //         this.dialogFormVisible=false

    //     }
    //     })
    //     }else{
    //         roleEdit({
    //         name:this.editForm.name,
    //         id:this.ids
    //     }).then(res=>{
    //     if(res.code==0){
    //         this.$message({
    //             type: 'success',
    //             message: '编辑成功'
    //           })
    //           this.formLIst()
    //         this.dialogFormVisible=false

    //     }
    //     })  
    //     }


    // },




    recommend(i, f) {
      if (i == -1) {
        this.recommendform.id = f.id
        this.recommendform.index = 0

        this.$confirm('确定要将该活动推荐取消吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {


          Axios({
            method: 'post',
            url: this.ssoServer + '/api/activity/updateIndex',

            headers: {
              tokenId: this.adder
            },
            data: this.recommendform
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '取消成功'
              })
              this.formLIst()
            }
          })

        }).catch(() => {

        });
        return

      } else {
        this.editFormVisible = true

      }
      this.recommendform.id = f.id


      this.recommendform.index = ''

    },




    addCogilg() {
      this.ifindex = '1'
      this.editForm.name = ''
      this.editForm.id = ''
      
      this.editForm.icon = ''
      this.editForm.parentId = ''
      this.editForm.url = ''
      this.editForm.sort = ''
      this.editForm.type = ''
      this.dialogFormVisible = true
    },
    selectall(val) {
      // console.log(val);

      let data = []
      // this.importList=''
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      // console.log(val);
    },



    change1(e) {
      console.log("change1", e);
      if (e.length === 1) {
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if (e.length === 2) {
        this.formInline.registerAddress = e[1];
      }
    },

    selectalls(rows) {

      if (rows) {
        let data = []
        rows.forEach((item) => {
          data.push(item.id)
          this.importList = data
          console.log(this.importList);

        })
        rows.forEach(row => {

          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        console.log('1212112');
        this.importList = []

        this.$refs.multipleTable.clearSelection();//清除全选
      }


    },

    onChange(e) {

      this.formInline.activityAddressCode = e[1]
      // console.log( this.formInline.registerAddress);


    },
    selectall(val) {

      let data = []
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      console.log(val);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出数据
    imporList() {
      if (this.importList.length == 0) {

        this.$message({
          type: 'warning',
          message: '请选择要导出的数据'
        })
        return

      } else {
        Axios({
          method: 'post',

          url: this.ssoServer + '/api/platform-account/exportExcel',
          headers: {
            tokenId: this.adder
          },
          data: {
            accountIds: this.importList,
            searchType: 1
          },
          responseType: 'blob'
        }).then(res => {
          const link = document.createElement('a') // 创建a标签
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
          link.href = window.URL.createObjectURL(blob)
          const filename = res.headers['content-disposition'].split('filename=')[1]
          link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
          link.click()
          window.URL.revokeObjectURL(link.href)
        })


      }




    },
    select(selection, row) {

      let data = []
      // this.importList=''
      selection.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
      //  this.formInline =''
      this.$refs[formInline].resetFields();
    },
    formLIst() {
      getMenuList(this.formInline).then(res => {
        if (res.code == 0) {
          this.listData = res.data
          // console.log(res.data.parentMenu);
          this.pageparm.total = res.data.total
        }
      })
    },
    formatData(row, column, cellValue, index) {

      //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
      //最终返回 s 就可以了
      var s = new Date(cellValue).toLocaleString();
      return s;
    },
    handleSizeChange(e) {
      // reru console.log(e.pageSize);
      this.formInline.size = e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
      // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
      this.formInline.current = 1
      this.value = (new Date()).getTime();

      this.formLIst()
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.$router.push({
        path: "/Eventmanagement/Eventdetails",
        query: { //query是个配置项
          id: row.id
        }
      })

      // this.editFormVisible = true
      // if (row != undefined && row != 'undefined') {
      //   this.title = '修改'
      //   this.editForm.deptId = row.deptId
      //   this.editForm.deptName = row.deptName
      //   this.editForm.deptNo = row.deptNo
      // } else {
      //   this.title = '添加'
      //   this.editForm.deptId = ''
      //   this.editForm.deptName = ''
      //   this.editForm.deptNo = ''
      // }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.recommendform.index == '') {
            return this.$message({
              type: 'warning',
              message: '推荐排序不能为空'
            })
          }
          Axios({
            method: 'post',
            url: this.ssoServer + '/api/activity/updateIndex',

            headers: {
              tokenId: this.adder
            },
            data: this.recommendform
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '推荐成功'
              })
              this.editFormVisible = false
              this.formLIst()

            } else {
              this.$message({
                type: 'warning',
                message: res.data.message
              })
              return

            }


          })
        }
      })
    },
    // async logins() {
    //     // 网络请求
    //     let data = await login('1111111');
    //     // let token = data.token;
    //     // 本地  vuex
    //     // this.$store.commit('LOGIN_IN',token);
    //     this.$router.replace("/")
    // },

    // 删除公司

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/adminiStration/permissions.vue